import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Store, MapPin, TrendingDown } from "lucide-react";

export default function StoresIndex() {
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/stores");
        setStores(data);
      } finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <h1 className="text-3xl sm:text-4xl font-display font-extrabold tracking-tight text-slate-900">Local stores</h1>
      <p className="text-slate-600 mt-1">Every registered Kiwi store posting markdowns.</p>

      {loading ? <div className="mt-8 text-slate-500">Loading…</div> : stores.length === 0 ? (
        <div className="mt-8 text-center py-16 border border-dashed border-slate-300 rounded-2xl bg-white text-slate-500" data-testid="stores-empty">
          No approved stores yet. <Link to="/register" className="text-emerald-800 underline underline-offset-4">Register the first one.</Link>
        </div>
      ) : (
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="stores-grid">
          {stores.map(s => (
            <Link key={s.id} to={`/store/${s.slug}`} className="card-lift bg-white rounded-2xl border border-slate-200 p-5 flex gap-4 items-center" data-testid={`store-card-${s.slug}`}>
              <div className="w-14 h-14 rounded-xl bg-emerald-100 text-emerald-900 grid place-items-center font-display font-black text-xl">{(s.store_name||"?").charAt(0)}</div>
              <div className="flex-1 min-w-0">
                <div className="font-display font-bold text-slate-900 truncate">{s.store_name}</div>
                <div className="text-xs text-slate-500 flex items-center gap-1 mt-0.5"><MapPin className="w-3 h-3" />{s.region}</div>
                <div className="text-xs text-emerald-800 font-semibold mt-1 flex items-center gap-1"><TrendingDown className="w-3.5 h-3.5" />{s.active_count} live markdowns</div>
              </div>
              <Store className="w-5 h-5 text-slate-300" />
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
